"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NcConfig", {
    enumerable: true,
    get: function() {
        return NcConfig;
    }
});
const _path = /*#__PURE__*/ _interop_require_wildcard(require("path"));
const _fs = /*#__PURE__*/ _interop_require_default(require("fs"));
const _util = require("util");
const _helpers = require("./helpers");
const _interfaces = require("./interfaces");
const _SqlClientFactory = require("~/db/sql-client/lib/SqlClientFactory");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
let NcConfig = class NcConfig {
    static async create(param) {
        var _ncConfig_meta_db_connection, _ncConfig_meta_db, _ncConfig_meta;
        const { meta, secret, port, worker, tryMode, publicUrl, dashboardPath } = param;
        const ncConfig = new NcConfig();
        ncConfig.auth = {
            jwt: {
                secret: secret
            }
        };
        ncConfig.port = +(port != null ? port : 8080);
        ncConfig.toolDir = (0, _helpers.getToolDir)();
        ncConfig.worker = worker != null ? worker : false;
        ncConfig.env = '_noco';
        ncConfig.workingEnv = '_noco';
        ncConfig.baseType = 'rest';
        if ((_ncConfig_meta = ncConfig.meta) == null ? void 0 : (_ncConfig_meta_db = _ncConfig_meta.db) == null ? void 0 : (_ncConfig_meta_db_connection = _ncConfig_meta_db.connection) == null ? void 0 : _ncConfig_meta_db_connection.filename) {
            ncConfig.meta.db.connection.filename = _path.join(ncConfig.toolDir, ncConfig.meta.db.connection.filename);
        }
        if (tryMode) {
            ncConfig.try = true;
            ncConfig.meta.db = {
                client: _interfaces.DriverClient.SQLITE,
                connection: ':memory:',
                pool: {
                    min: 1,
                    max: 1,
                    // disposeTimeout: 360000*1000,
                    idleTimeoutMillis: 360000 * 1000
                }
            };
        } else {
            if (meta == null ? void 0 : meta.metaUrl) {
                ncConfig.meta.db = await (0, _helpers.metaUrlToDbConfig)(meta.metaUrl);
            } else if (meta == null ? void 0 : meta.metaJson) {
                ncConfig.meta.db = JSON.parse(meta.metaJson);
            } else if (meta == null ? void 0 : meta.metaJsonFile) {
                if (!await (0, _util.promisify)(_fs.default.exists)(meta.metaJsonFile)) {
                    throw new Error(`NC_DB_JSON_FILE not found: ${meta.metaJsonFile}`);
                }
                const fileContent = await (0, _util.promisify)(_fs.default.readFile)(meta.metaJsonFile, {
                    encoding: 'utf8'
                });
                ncConfig.meta.db = JSON.parse(fileContent);
            }
        }
        if (publicUrl) {
            ncConfig.publicUrl = publicUrl;
        }
        if (dashboardPath) {
            ncConfig.dashboardPath = dashboardPath;
        } else {
            ncConfig.dashboardPath = '/dashboard';
        }
        try {
            // make sure meta db exists
            await ncConfig.metaDbCreateIfNotExist();
        } catch (e) {
            throw new Error(e);
        }
        return ncConfig;
    }
    static async createByEnv() {
        var _process_env_NC_DASHBOARD_URL;
        return NcConfig.create({
            meta: {
                metaUrl: process.env.NC_DB,
                metaJson: process.env.NC_DB_JSON,
                metaJsonFile: process.env.NC_DB_JSON_FILE
            },
            secret: process.env.NC_AUTH_JWT_SECRET,
            port: process.env.NC_PORT,
            tryMode: !!process.env.NC_TRY,
            worker: !!process.env.NC_WORKER,
            dashboardPath: (_process_env_NC_DASHBOARD_URL = process.env.NC_DASHBOARD_URL) != null ? _process_env_NC_DASHBOARD_URL : '/dashboard',
            publicUrl: process.env.NC_PUBLIC_URL
        });
    }
    async metaDbCreateIfNotExist() {
        var _this_meta_db, _this_meta;
        if (((_this_meta = this.meta) == null ? void 0 : (_this_meta_db = _this_meta.db) == null ? void 0 : _this_meta_db.client) === 'sqlite3') {
            var _this_meta_db_connection, _this_meta_db1;
            const metaSqlClient = await _SqlClientFactory.SqlClientFactory.create(_extends({}, this.meta.db, {
                connection: this.meta.db
            }));
            if ((_this_meta_db1 = this.meta.db) == null ? void 0 : (_this_meta_db_connection = _this_meta_db1.connection) == null ? void 0 : _this_meta_db_connection.filename) {
                var _this_meta_db_connection1, _this_meta_db2;
                await metaSqlClient.createDatabaseIfNotExists({
                    database: (_this_meta_db2 = this.meta.db) == null ? void 0 : (_this_meta_db_connection1 = _this_meta_db2.connection) == null ? void 0 : _this_meta_db_connection1.filename
                });
            } else {
                throw new Error('Meta database configuration missing SQLite file name');
            }
            await metaSqlClient.knex.destroy();
        } else {
            var _this_meta_db_connection2, _this_meta_db3;
            const metaSqlClient = await _SqlClientFactory.SqlClientFactory.create(this.meta.db);
            if ((_this_meta_db3 = this.meta.db) == null ? void 0 : (_this_meta_db_connection2 = _this_meta_db3.connection) == null ? void 0 : _this_meta_db_connection2.database) {
                await metaSqlClient.createDatabaseIfNotExists(this.meta.db.connection);
                await metaSqlClient.knex.destroy();
            } else {
                throw new Error('Meta database configuration missing database name');
            }
        }
    }
    static get isAuditEnabled() {
        return process.env.NC_ENABLE_AUDIT === 'true';
    }
    constructor(){
        this.meta = {
            db: {
                client: _interfaces.DriverClient.SQLITE,
                connection: {
                    filename: 'noco.db'
                }
            }
        };
    }
};
